import React from 'react';
import ReactDOM from 'react-dom/client';
// Imported before App so the app's own stylesheets still override it, as when it loaded from a CDN in index.html.
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
// v7_startTransition keeps the current page on screen while the next page's code chunk loads, instead of blanking it.
root.render(
    <BrowserRouter future={{v7_startTransition: true}}>
        <App/>
    </BrowserRouter>
);
